import { render, staticRenderFns } from "./FormulateHtmlContent.vue?vue&type=template&id=b217b2d8&scoped=true"
import script from "./FormulateHtmlContent.vue?vue&type=script&lang=js"
export * from "./FormulateHtmlContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b217b2d8",
  null
  
)

export default component.exports